<div class="form-group row entry">
  <label class="col-4 col-form-label">{{title}}</label>
  <div class="col-8" *ngIf="email">
    <a href="mailto:{{value}}"> {{value}} </a>
  </div>
  <div class="col-8" *ngIf="!email">
    {{value}}
  </div>
</div>
